module.exports = __webpack_public_path__ + "img/barraFondo2.32f4b0e3.svg";